import { Component, Input } from '@angular/core';
import { BatteryStatus } from 'src/app/models/beacon';

@Component({
  selector: 'app-battery-status',
  templateUrl: './battery-status.component.html',
  styleUrls: ['./battery-status.component.scss'],
})
export class BatteryStatusComponent {
  @Input()
  status: BatteryStatus;

  @Input()
  percent: number;

  getBatteryIcon() {
    switch (this.status) {
      case 'critical':
        return 'battery_alert';
      case 'good':
        return 'battery_60';
      case 'low':
        return 'battery_20';
      case 'new':
        return 'battery_full';

      default:
        return 'battery_unknown';
    }
  }
}
